module.exports = __webpack_public_path__ + "img/ra-text-animated.b924a840.gif";